import { useEffect } from 'react'
import { useRecoilState } from 'recoil'

import { SegmentControlAtom } from '../recoil/atoms'
import { generateUUID } from '../utils/display'
import CardWithBorder from './CardWithBorder'
import Loader from './Loader'

interface CardProps {
  className?: string
  title: string
  children: React.ReactNode
  segmentTitle: string
  segments: { label: string; value: string }[]
  visible: boolean
}

function CardWithSegmentControl({ className, title, children, segmentTitle, segments, visible }: CardProps) {
  const [segVal, setSegVal] = useRecoilState(SegmentControlAtom(segmentTitle))

  useEffect(() => {
    if (segVal === '') {
      setSegVal(segments[0].value)
    }
  })

  return (
    <CardWithBorder className={`grid grid-cols-2 ${className}`} title={title}>
      <div className='gap-2 justify-self-end'>
        {segments.map((segment) => (
          <button
            key={generateUUID()}
            type='button'
            className={`px-[14px] py-2 rounded-md mr-2 text-sm font-semibold border border-[#001E61] ${
              segVal === segment.value
                ? 'bg-[#001E61] text-white'
                : 'bg-white text-[#001E61] hover:bg-[#001E61] hover:text-white'
            }`}
            onClick={() => setSegVal(segment.value)}
          >
            {segment.label}
          </button>
        ))}
      </div>
      <div className='col-span-2'>
        <Loader visible={visible} />
        {visible ? <div className='w-full min-h-[33vh]' /> : children}
      </div>
    </CardWithBorder>
  )
}

CardWithSegmentControl.defaultProps = {
  className: '',
}

export default CardWithSegmentControl
